import digitalData from 'digital-data';

export const deliveryOptions = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('@@delivery-options/CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@delivery-options/CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('delivery-options.click', ({ output }) => {
    const {
      eventName,
      primaryCategory
    } = output;

    const ddoEvent = {
      eventInfo: {
        eventName
      },
      category: {
        primaryCategory
      }
    };
    digitalData.event.push(ddoEvent);
  });

};
